import UICreatorComponent from "@baseUI/utils/UICreatorComponent";
import UIFacade from "@baseUI/UIFacade";
import Paytable from "@baseUI/component/specials/Paytable";
import Facade from "@/Facade";
import UICreatorGraphics from "@baseUI/utils/UICreatorGraphics";
import UICreatorText from "@baseUI/utils/UICreatorText";

class InfoSettingsPartArranger {
    create(data, wrapper, settings) {
        const {contentWidth} = settings;
        const chapters = [];

        for (const chapter of Object.keys(data)) {
            if (data[chapter].linked_to_bonus !== undefined &&
                data[chapter].linked_to_bonus &&
                Facade.model.buyFreebet.length <= 0
            ) {
                continue;
            }
            const container = UICreatorComponent.addContainer(wrapper);

            const items = data[chapter].items !== undefined ?
                data[chapter].items :
                data[chapter];

            items.forEach(field => {
                let element = null;

                if(field.country !== undefined && field.country.toLowerCase() !== Facade.model.country.toLowerCase()){
                    return;
                }

                switch (field.type) {
                    case 'textTitle':
                        element = UICreatorText.addElementTextName(field.key, container, [0, 0], 0);
                        break;
                    case 'textItem':
                        const textItem = UICreatorComponent.addContainer(container);
                        element = textItem;

                        UICreatorGraphics.addRect(textItem, 0, 20, 10, 10);

                        const textName = UICreatorText.addElementTextName(field.key, textItem, [30, 0], 0);
                        textName.key = field.key;
                        textName.style.wordWrap = true;
                        textName.style.wordWrapWidth = contentWidth;

                        container.addChild(textItem);
                        break;
                    case 'textMaxWin':
                        const textMaxWin = (UIFacade.textFactory.getLocalizedText(field.key)).replace(field.holder, "X" + UIFacade.model.maxwin);
                        element = UICreatorText.addElementTextSimple(textMaxWin, 'infoSmallText', container, [0, 0], 0)
                        element.key = field.key;
                        element.style.wordWrap = true;
                        element.style.wordWrapWidth = contentWidth;
                        break;
                    case 'textRTP':
                        const textRTP = (UIFacade.textFactory.getLocalizedText(field.key)).replace(field.holder, UIFacade.model.rtp + '%');
                        element = UICreatorText.addElementTextSimple(textRTP, 'infoSmallText', container, [0, 0], 0)
                        element.key = field.key;
                        element.style.wordWrap = true;
                        element.style.wordWrapWidth = contentWidth;
                        break;
                    case 'text':
                        const text = (UIFacade.textFactory.getLocalizedText(field.key));
                        element = UICreatorText.addElementTextSimple(text, 'infoSmallText', container, [0, 0], 0)
                        element.key = field.key;
                        element.style.wordWrap = true;
                        element.style.wordWrapWidth = contentWidth;
                        break;
                    case 'textBonusBuyRTP':
                        const textBonusBuyRTP = (UIFacade.textFactory.getLocalizedText(field.key)).replace(field.holder, UIFacade.model.rtpBonusBuy.toFixed(2) + '%');
                        element = UICreatorText.addElementTextSimple(textBonusBuyRTP, 'infoSmallText', container, [0, 0], 0)
                        element.key = field.key;
                        element.style.wordWrap = true;
                        element.style.wordWrapWidth = contentWidth;
                        break;
                    case 'line':
                        element = UICreatorGraphics.addSeparator(container, contentWidth + 80);
                        break;
                    case 'image':
                        element = UICreatorComponent.addElementOld(field.name, container, [0, 0], 'info', 1.25)
                        break;
                    case 'paytable':
                        const paytable = new Paytable(container, {width: contentWidth});
                        paytable.build();
                        element = paytable;
                        break;
                }

                if (!element) {
                    throw new Error('InfoChapters.json contains wrong field type. Sort out that with InfoSettingsPartArranger.js');
                }

                element.type = field.type;
            })

            container.name = chapter;
            chapters.push(container);
        }

        this.arrangeItems(chapters, settings);
    }

    arrangeItems(chapters, settings) {
        const {chaptersGap, fieldsGap, imageArranger} = settings;
        const proceed = () => {
            chapters.forEach((chapter, i, blocks) => {
                chapter.children.forEach((element, index, all) => {

                    // Set position of each element in chapter depends on previous element.
                    const prevElement = all[index - 1];

                    if (prevElement) {
                        element.y = prevElement.height + prevElement.y + fieldsGap;
                    } else {
                        element.y = 0;
                    }

                    // Side image has specific position
                    if (element.type === 'image') {
                        imageArranger(element, chapter);
                    }
                });

                // Set position of each chapter block
                const prevChapter = blocks[i - 1];

                if (prevChapter) {
                    chapter.y = prevChapter.height + prevChapter.y + chaptersGap;
                } else {
                    chapter.y = 0;
                }
            })
        }
        setTimeout(() => proceed(), 1000);
    }

}

export default InfoSettingsPartArranger;
